<template>
  <div class="cart mt-5">
    <h1>Keranjang</h1>
    <v-col class="pt-5">
      <div v-if="cartData.length == 0 && !cartPagination">
        <v-card class="rounded-lg mb-5">
          <v-col class="pa-5">
            <vcl :width="300" :height="75">
              <rect x="0" y="0" rx="2" ry="2" width="50" height="5" />
              <rect x="0" y="10" rx="2" ry="2" width="40" height="5" />
              <rect x="85" y="10" rx="2" ry="2" width="40" height="5" />
              <rect x="140" y="10" rx="2" ry="2" width="40" height="5" />
              <rect x="200" y="10" rx="2" ry="2" width="40" height="5" />
              <rect x="255" y="10" rx="2" ry="2" width="40" height="5" />
              <rect x="5" y="25" rx="2" ry="2" width="20" height="20" />
              <rect x="30" y="32" rx="2" ry="2" width="40" height="5" />
              <rect x="85" y="32" rx="2" ry="2" width="40" height="5" />
              <rect x="140" y="32" rx="2" ry="2" width="40" height="5" />
              <rect x="200" y="32" rx="2" ry="2" width="40" height="5" />
              <rect x="255" y="32" rx="2" ry="2" width="40" height="5" />
              <rect x="5" y="57" rx="2" ry="2" width="40" height="5" />
              <rect x="5" y="67" rx="2" ry="2" width="50" height="5" />
              <rect x="85" y="57" rx="2" ry="2" width="40" height="5" />
              <rect x="85" y="67" rx="2" ry="2" width="50" height="5" />
              <rect x="245" y="60" rx="2" ry="2" width="50" height="10" />
            </vcl>
          </v-col>
        </v-card>
      </div>
      <div class="pb-5" v-else-if="cartData.length == 0 && cartPagination">
        <div class="pb-5 text-center">
          <v-row class="justify-center">
            <v-col cols="6" sm="5" md="3" class="pb-1">
              <v-img width="100%" src="/assets/icons/ilus-keranjang-kosong.svg" />
            </v-col>
          </v-row>
          <div class="text-body-1 text-sm-h5 font-weight-bold my-auto text-center">Keranjang Kamu masih kosong lho...
          </div>
          <div class="text-body-2 text-sm-body-1 text-center pt-2">Yuk, isi keranjang Anda sekarang</div>
          <div class="pt-4">
            <router-link to="/" class="text-deco">
              <v-btn large color="black" class="text-capitalize white--text font-weight-bold rounded-lg">Belanja
                Sekarang</v-btn>
            </router-link>
          </div>
        </div>
      </div>
      <!-- <div v-if="cartData.length == 0 && !cartPagination">
				masih di load
      </div>-->
      <div v-else>
        <v-row v-for="cart in cartData" :key="cart.cart_id">
          <v-col :cols="12" :sm="12" :md="8">
            <v-card class="rounded-lg mb-5">
              <v-col class="pa-5">
                <div>
                  <div class="text-uppercase font-weight-bold black--text text-body-2 pb-2">
                    <v-icon color="#1951EF" class="mt-n1">mdi-storefront</v-icon>
                    <span class="pl-3">{{ cart.store_name }}</span>
                  </div>
                  <v-list three-line>
                    <template>
                      <template v-if="cart.cart_detail.length > 0">
                        <v-list-item class="px-0" v-for="item in cart.cart_detail" :key="item.cart_detail_id">
                          <v-list-item-avatar width="120" rounded="0" height="120">
                            <router-link
                              :to="{ name: 'product-detail', params: { slug: item.product_slug_name, id: item.product_id } }">
                              <v-card outlined>
                                <v-col class="pa-1">
                                  <v-img class="rounded-lg" width="100" height="100" :src="item.product_image"></v-img>
                                </v-col>
                              </v-card>
                            </router-link>
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <div class=""><v-badge v-if="item.product_physique == 'ebook'" color="red darken-1"
                                content="E-book" inline>
                              </v-badge></div>
                            <div class="my-auto">
                              <router-link class="text-decoration-none black--text" style="font-weight: unset;"
                                :to="{ name: 'product-detail', params: { slug: item.product_slug_name, id: item.product_id } }">
                                <h3>{{ item.product_name }}</h3>
                              </router-link>
                              <div v-if="item.product_pv > 0">{{ item.product_pv }} PV</div>
                            </div>
                            <div class="text-decoration-line-through font-size-10 pink--text"
                              v-if="item.product_price != item.product_price_origin">{{
                                item.product_price_origin | toNumber
                              }}</div>
                            <div>Rp.{{ item.product_price | toNumber }}</div>
                            <div class="text-caption">
                              <span v-if="item.product_enable_discount == '1'" class="red white--text">{{
                                item.product_discount_percent | toNumber }}%</span>
                              &nbsp;
                              <strike v-if="item.product_enable_discount == '1'">Rp {{ item.product_gross | toNumber
                              }}</strike>
                            </div>
                            <v-row class="justify-end">
                              <v-col class="d-flex flex-column justify-center" :cols="4">
                                <v-btn text color="pink"
                                  @click="removeProduct(cart.cart_store_id, item.product_id, item.product_name)">
                                  <v-icon>mdi-delete</v-icon>
                                </v-btn>
                              </v-col>
                              <v-col :md="4" v-if="item.product_physique !== 'ebook'">
                                <div class="d-flex ">
                                  <v-btn text x-small color="#1951EF" height="35"
                                    :disabled="item.cart_detail_quantity < 2" @click="item.cart_detail_quantity--"
                                    @click.stop="update(cart.cart_store_id, item.product_id, item.product_name, item.cart_detail_quantity)">
                                    <v-icon>mdi-minus-circle</v-icon>
                                  </v-btn>
                                  <v-currency-field class="input-center" v-model="item.cart_detail_quantity"
                                    @blur="update(cart.cart_store_id, item.product_id, item.product_name, item.cart_detail_quantity)"
                                    dense hide-details="auto"></v-currency-field>
                                  <v-btn text x-small color="#1951EF" height="35" @click="item.cart_detail_quantity++"
                                    @click.stop="update(cart.cart_store_id, item.product_id, item.product_name, item.cart_detail_quantity)">
                                    <v-icon>mdi-plus-circle</v-icon>
                                  </v-btn>
                                </div>
                              </v-col>
                            </v-row>
                          </v-list-item-content>
                          <!-- <v-list-item-content class="d-none d-md-block">
                            <div class="my-auto">
                              <div v-if="item.product_pv > 0">{{ item.product_pv }} PV</div>
                              <v-badge v-if="item.product_physique == 'ebook'" color="red darken-1" content="E-book"
                                inline>
                              </v-badge>
                            </div>
                            <div class="text-decoration-line-through font-size-10 pink--text" v-if="true">{{
                              item.product_price_origin | toNumber
                            }}</div>
                            <div>Rp.{{ item.product_price | toNumber }}</div>
                            <div class="text-caption">
                              <span v-if="item.product_enable_discount == '1'" class="red white--text">{{
                                item.product_discount_percent | toNumber }}%</span>
                              &nbsp;
                              <strike v-if="item.product_enable_discount == '1'">Rp {{ item.product_gross | toNumber
                              }}</strike>
                            </div>
                          </v-list-item-content> -->
                        </v-list-item>
                      </template>
                      <template v-else>
                        <div class="pb-5 text-center">
                          <v-row class="justify-center">
                            <v-col cols="6" sm="5" md="3" class="pb-1">
                              <v-img width="100%" src="/assets/icons/ilus-keranjang-kosong.svg" />
                            </v-col>
                          </v-row>
                          <div class="text-body-1 text-sm-h5 font-weight-bold my-auto text-center">Keranjang Kamu masih
                            kosong lho...
                          </div>
                          <div class="text-body-2 text-sm-body-1 text-center pt-2">Yuk, isi keranjang Anda sekarang</div>
                          <div class="pt-4">
                            <router-link to="/" class="text-deco">
                              <v-btn large color="black"
                                class="text-capitalize white--text font-weight-bold rounded-lg">Belanja
                                Sekarang</v-btn>
                            </router-link>
                          </div>
                        </div>
                      </template>
                    </template>
                  </v-list>
                  <v-simple-table v-if="false" class="no-hover-bg table-cart">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left text-subtitle-2" width="30%">Produk</th>
                          <th class="text-center text-subtitle-2">Harga (Rp)</th>
                          <th class="text-center text-subtitle-2" width="17%">Jumlah</th>
                          <th class="text-center text-subtitle-2">Sub Total (Rp)</th>
                          <th class="text-center text-subtitle-2">Hapus</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in cart.cart_detail" :key="item.cart_detail_id">
                          <td class="py-5">
                            <router-link
                              :to="{ name: 'product-detail', params: { slug: item.product_slug_name, id: item.product_id } }"
                              class="text-deco">
                              <div class="d-flex">
                                <v-card outlined>
                                  <v-col class="pa-1">
                                    <v-img class="rounded-lg" width="70" height="70" :src="item.product_image"></v-img>
                                  </v-col>
                                </v-card>
                                <div class="my-auto pl-3">
                                  <div>{{ item.product_name }}</div>
                                  <div v-if="item.product_pv > 0">{{ item.product_pv }} PV</div>
                                  <v-badge v-if="item.product_physique == 'ebook'" color="red darken-1" content="E-book"
                                    inline>
                                  </v-badge>
                                </div>
                              </div>
                            </router-link>
                            <div class="pt-3" v-if="false">
                              <div class="text-caption font-weight-bold">
                                Catatan
                                <small>(Optional)</small>
                              </div>
                              <div>
                                <v-text-field dense hide-details="auto" class="mt-0 text-body-2"></v-text-field>
                              </div>
                            </div>
                          </td>
                          <td class="text-center" v-if="false">
                            {{ item.product_price | toNumber }}
                            <sup v-if="item.product_price != item.product_price_origin"
                              class="text-decoration-line-through font-size-10 pink--text">{{ item.product_price_origin |
                                toNumber }}</sup>
                          </td>
                          <td class="text-center">
                            <div class="text-decoration-line-through font-size-10 pink--text"
                              v-if="item.product_price != item.product_price_origin">{{ item.product_price_origin |
                                toNumber
                              }}</div>
                            <div>{{ item.product_price | toNumber }}</div>
                            <div class="text-caption">
                              <span v-if="item.product_enable_discount == '1'" class="red white--text">{{
                                item.product_discount_percent | toNumber }}%</span>
                              &nbsp;
                              <strike v-if="item.product_enable_discount == '1'">Rp {{ item.product_gross | toNumber
                              }}</strike>
                            </div>
                          </td>
                          <td class="my-auto">
                            <div class="d-flex py-3">
                              <v-btn text x-small color="#1951EF" height="35" :disabled="item.cart_detail_quantity < 2"
                                @click="item.cart_detail_quantity--"
                                @click.stop="update(cart.cart_store_id, item.product_id, item.product_name, item.cart_detail_quantity)">
                                <v-icon>mdi-minus-circle</v-icon>
                              </v-btn>
                              <v-currency-field class="input-center" v-model="item.cart_detail_quantity"
                                @blur="update(cart.cart_store_id, item.product_id, item.product_name, item.cart_detail_quantity)"
                                dense hide-details="auto"></v-currency-field>
                              <v-btn text x-small color="#1951EF" height="35" @click="item.cart_detail_quantity++"
                                @click.stop="update(cart.cart_store_id, item.product_id, item.product_name, item.cart_detail_quantity)">
                                <v-icon>mdi-plus-circle</v-icon>
                              </v-btn>
                            </div>
                          </td>
                          <td class="text-center black--text font-weight-bold">{{ item.product_price *
                            item.cart_detail_quantity | toNumber }}</td>
                          <td class="text-center">
                            <v-btn text color="pink"
                              @click="removeProduct(cart.cart_store_id, item.product_id, item.product_name)">
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
              </v-col>
            </v-card>
          </v-col>
          <v-col :cols="12" :sm="12" :md="4">
            <div class="d-none d-md-block">
              <v-card outlined class="psr-border rounded-0 pa-2" color="  lighten-5">
                <v-row class="px-4">
                  <v-col cols="12">
                    <div class="text-md-h6 font-weight-bold">Total Belanja</div>
                    <div class="text-body-2 grey--text text--darken-1">{{ countItem(cart.cart_detail) | toNumber }} item
                      dari {{ cart.cart_detail.length }} produk</div>
                  </v-col>
                  <v-col cols="12">
                    <div class="text-md-h6 font-weight-bold">Rp {{ countPrice(cart.cart_detail) | toNumber }}</div>
                    <div class="text-body-2 grey--text text--darken-1">Belum Ongkos Kirim</div>
                  </v-col>
                  <v-col cols="12" class="my-auto">
                    <v-btn :disabled="cart.cart_detail.length < 1" depressed block color="#1951EF"
                      @click="getDetail(cart.cart_id)" height="40"
                      class="rounded-lg font-weight-bold white--text">Checkout</v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </v-col>
          <div class="mobile-add-cart d-block d-md-none">
            <v-row class="px-4">
              <v-col cols="6">
                <div class="text-md-h6 font-weight-bold">Total Belanja</div>
                <div class="text-body-2 grey--text text--darken-1">{{ countItem(cart.cart_detail) | toNumber }} item
                  dari {{ cart.cart_detail.length }} produk</div>
              </v-col>
              <v-col cols="6">
                <div class="text-md-h6 font-weight-bold">Rp {{ countPrice(cart.cart_detail) | toNumber }}</div>
                <div class="text-body-2 grey--text text--darken-1">Belum Ongkos Kirim</div>
              </v-col>
              <v-col cols="12" class="my-auto">
                <v-btn :disabled="cart.cart_detail.length < 1" depressed block color="#1951EF"
                  @click="getDetail(cart.cart_id)" height="40"
                  class="rounded-lg font-weight-bold white--text">Checkout</v-btn>
              </v-col>
            </v-row>
          </div>
        </v-row>
      </div>
      <ProductCarousel ref="recomended" type="recomended" :product="productTrend"></ProductCarousel>
    </v-col>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import ProductCarousel from "@/views/store/product/ProductCarousel";
// import debounce from '@/helpers/debounce'

export default {
  components: {
    ProductCarousel
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("auth", ["userData"]),
    ...mapState("cart", ["cartData", "cartPagination"]),
    ...mapState("productExternal", ["productTrend"])
  },
  methods: {
    ...mapActions("cart", [
      "getCart",
      "updateItemCart",
      "removeProductCart",
      "getCartDetail"
    ]),
    ...mapActions("productExternal", ["getProductTrend"]),
    ...mapMutations(["makeAlert"]),

    update(store_id, product_id, product_name, qty) {
      let params = {
        store_id: store_id,
        product_id: product_id,
        product_name: product_name,
        quantity: qty
      };
      this.updateItemCart(params)
        .then(() => {
          this.getCart();
        })
        .catch(() => {
          this.getCart();
        });
    },
    removeProduct(store_id, product_id, product_name) {
      let params = {
        store_id: store_id,
        product_id: product_id,
        product_name: product_name
      };
      this.removeProductCart(params)
        .then(() => {
          this.getCart();
        })
        .catch(() => {
          return false;
        });
    },
    getDetail(id) {
      this.getCartDetail({
        id: id
      })
        .then(() => {
          this.$router.push({ name: "checkout" });
        })
        .catch(err => {
          this.makeAlert({
            code: "error_response",
            type: "error",
            message: err.message,
            show: true
          });
        });
    },
    countItem(data) {
      let count = 0;
      data.forEach(el => {
        count += parseInt(el.cart_detail_quantity);
      });
      return count;
    },
    countPrice(data) {
      let count = 0;
      data.forEach(el => {
        count += parseInt(el.cart_detail_quantity) * parseInt(el.product_price);
      });
      return count;
    }
  },
  watch: {},
  created() {
    this.$store.dispatch("setPageTitle", "Keranjang");
    this.getCart();
    this.getProductTrend();
  },
  mounted() {
    document.getElementsByClassName('v-footer')[0].classList.add("footer-fixed-padding");
  },
  destroyed() {
    const footer = document.getElementsByClassName('v-footer')[0]
    if (footer.classList.contains("footer-fixed-padding")) {
      footer.classList.remove("footer-fixed-padding");
    }
  }

};
</script>